const manifest = {
  key: 'magic',
  name: 'Magic Moments',
  description: 'Word + photo reveal experience ("Let\'s make magic") ahead of code entry.',
  thumbnail: '/assets/images/templates/magic-thumbnail.png',
  // When false: hidden from the dashboard's Template tab and excluded entirely from the production build.
  is_deploy: true
};

export default manifest;
